export default {
	// Login
	AUTH_LOGIN_REQUEST: 'AUTH_LOGIN_REQUEST',
	AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
	AUTH_LOGIN_FAILURE: 'AUTH_LOGIN_FAILURE',
	// Logout
	AUTH_LOGOUT: 'AUTH_LOGOUT',
	// API unauthenticated note: generated by redux-api-request, handled by Auth
	API_UNAUTHENTICATED: 'API_UNAUTHENTICATED',
	API_UNAUTHORIZED: 'API_UNAUTHORIZED',
}


// WEBPACK FOOTER //
// ./src/modules/auth/auth.constants.js